package com.bikompanion.data.cache

import kotlinx.serialization.Serializable

@Serializable
internal data class CachedNetwork(
    val id: String,
    val name: String,
    val latitude: Double,
    val longitude: Double,
    val city: String,
    val country: String,
    val company: List<String> = emptyList(),
    val href: String = "",
    val licenseName: String = "",
    val licenseUrl: String = "",
    val coverage: CachedCoverage? = null,
)
